import { Component, OnInit, ViewEncapsulation, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'swb-categories',
  templateUrl: './categories.component.html',
  encapsulation: ViewEncapsulation.None
})
export class CategoriesComponent implements OnInit {

  public query: string;

  @Output() filterEvent = new EventEmitter<string>();

  constructor() { }

  ngOnInit() {
  }

  public filter(query: string): void {
    this.query = query;
  }


}
